import React, {Component} from "react";
import SecureLayout from "./../../../templates/secure";

class LinesSearch extends Component {
	render() {
		const { lines } = this.props;
		return <div className="field has-addons">
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._clearSearch}>
					&nbsp;&nbsp;
					<span className="icon is-small">
						<i className="fa fa-ban"/>
					</span>
				</a>
			</div>

			<div className="control">
				<input className="input is-small" type="search" ref="q" id="q" placeholder="Buscar" value={lines.filters.q} onChange={this._searchChange}/>
			</div>
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._submitSearch}>Buscar</a>
			</div>
		</div>
	}

	constructor() {
		super();
		this._submitSearch = this._submitSearch.bind(this);
		this._searchChange = this._searchChange.bind(this);
		this._clearSearch = this._clearSearch.bind(this);
	}

	_submitSearch() {
		const {lines} = this.props;
		this.props.linesShow(1,lines.filters);
	}

	_searchChange(event){
		this.props.change('lines.filters.q',event.target.value);
	}

	_clearSearch(){
		this.props.reset('lines.filters');
		this.props.linesShow(1);
	}
}

export default SecureLayout(LinesSearch);



// WEBPACK FOOTER //
// ./src/elements/lines/widget/lines_search.jsx